<template>
  <div id="role">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: 'role'
}
</script>




// WEBPACK FOOTER //
// src/views/system/role/Role.vue